import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import { MedicalToolSetSummaryModel } from "./medicalToolSetSummary.model";
import {MedicalSterilizationSummaryModel} from "../../../sterilization/api/entity/medicalSterilizationSummary.model";

export class MedicalToolSetModel implements IWithSummaryModel<MedicalToolSetSummaryModel> {
    summary: MedicalToolSetSummaryModel;
    sterilization: MedicalSterilizationSummaryModel;

    get label() {
        return this.summary.getLabel(this.sterilization);
    }
}

export const MEDICAL_TOOL_SET_LABEL = '<?xml version="1.0" encoding="utf-8"?>\n' +
    ' <DieCutLabel Version="8.0" Units="twips">\n' +
    ' <PaperOrientation>Landscape</PaperOrientation>\n' +
    ' <Id>ReturnAddressInt</Id>\n' +
    ' <PaperName>11352 Return Address Int</PaperName>\n' +
    ' <DrawCommands>\n' +
    ' <RoundRectangle X="0" Y="0" Width="1440" Height="3060" Rx="180" Ry="180" />\n' +
    ' </DrawCommands>\n' +
    ' <ObjectInfo>\n' +
    ' <TextObject>\n' +
    ' <Name>TEXTE_1</Name>\n' +
    ' <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n' +
    ' <BackColor Alpha="0" Red="255" Green="255" Blue="255" />\n' +
    ' <LinkedObjectName></LinkedObjectName>\n' +
    ' <Rotation>Rotation0</Rotation>\n' +
    ' <IsMirrored>False</IsMirrored>\n' +
    ' <IsVariable>False</IsVariable>\n' +
    ' <HorizontalAlignment>Left</HorizontalAlignment>\n' +
    ' <VerticalAlignment>Top</VerticalAlignment>\n' +
    ' <TextFitMode>ShrinkToFit</TextFitMode>\n' +
    ' <UseFullFontHeight>True</UseFullFontHeight>\n' +
    ' <Verticalized>False</Verticalized>\n' +
    ' <StyledText>\n' +
    ' <Element>\n' +
    ' <String>{{businessIdentifier}}\n' +
    'Par {{responsible}} le {{sterilizationDate}}\n' +
    'Validité {{validationDate}}\n' +
    '</String>\n' +
    ' <Attributes>\n' +
    ' <Font Family="Tahoma" Size="13" Bold="False" Italic="False" Underline="False" Strikeout="False" />\n' +
    ' <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n' +
    ' </Attributes>\n' +
    ' </Element>\n' +
    ' </StyledText>\n' +
    ' </TextObject>\n' +
    ' <Bounds X="130" Y="57" Width="2846" Height="749" />\n' +
    ' </ObjectInfo>\n' +
    ' </DieCutLabel>';
